import { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Collapse, Typography, Spin, Empty } from "antd";
import { useDispatch, useSelector } from "react-redux";
import _isEmpty from "lodash/isEmpty";
import {
  renameProductTypeRequest,
  getProductTypeRequest,
} from "providers/ProductProvider/slice";
import EditableTypeItem from "./EditableTypeItem";
import EditableSeriesItem from "./EditableSeriesItem";

const { Panel } = Collapse;

const EditTab = ({ productTypes }) => {
  const dispatch = useDispatch();
  const [localProductTypes, setLocalProductTypes] = useState(productTypes);
  const isUpdateTypeLoading = useSelector(
    (state) => state.product.isUpdateTypeLoading
  );

  useEffect(() => {
    setLocalProductTypes(productTypes);
  }, [productTypes]);

  const handleUpdateTypeName = (typeId, newName) => {
    const typeToUpdate = localProductTypes.find((t) => t._id === typeId);
    if (!typeToUpdate || typeToUpdate.name === newName) return;

    dispatch(
      renameProductTypeRequest({
        idProductType: typeId,
        newProductTypeName: newName,
      })
    ).then(() => {
      dispatch(getProductTypeRequest());
      setLocalProductTypes((prev) =>
        prev.map((t) => (t._id === typeId ? { ...t, name: newName } : t))
      );
    });
  };

  const handleUpdateSeriesName = (typeId, seriesId, newName) => {
    const typeToUpdate = localProductTypes.find((t) => t._id === typeId);
    if (!typeToUpdate) return;

    const series = typeToUpdate.machineSeries.find((s) => s.id === seriesId);
    if (!series || series.name === newName) return;

    dispatch(
      renameProductTypeRequest({
        idProductType: typeId,
        machineSeriesId: seriesId,
        newMachineSeriesName: newName,
      })
    ).then(() => {
      dispatch(getProductTypeRequest());
      setLocalProductTypes((prev) =>
        prev.map((t) =>
          t._id === typeId
            ? {
                ...t,
                machineSeries: t.machineSeries.map((s) =>
                  s.id === seriesId ? { ...s, name: newName } : s
                ),
              }
            : t
        )
      );
    });
  };

  if (_isEmpty(localProductTypes)) {
    return (
      <div className="edit-tab-container">
        <Empty
          description="Chưa có loại sản phẩm nào"
          className="no-types"
        />
      </div>
    );
  }

  return (
    <Spin spinning={isUpdateTypeLoading}>
      <div className="edit-tab-container">
        <div className="edit-type-list">
          <Collapse accordion>
            {localProductTypes.map((productType) => (
              <Panel
                key={productType._id}
                header={
                  <EditableTypeItem
                    productType={productType}
                    onSave={(newName) =>
                      handleUpdateTypeName(productType._id, newName)
                    }
                  />
                }
              >
                <div className="series-list">
                  {_isEmpty(productType.machineSeries) ? (
                    <Typography.Text type="secondary" className="no-series">
                      Chưa có dòng máy nào
                    </Typography.Text>
                  ) : (
                    productType.machineSeries.map((series) => (
                      <EditableSeriesItem
                        key={series.id}
                        series={series}
                        onSave={(newName) =>
                          handleUpdateSeriesName(
                            productType._id,
                            series.id,
                            newName
                          )
                        }
                      />
                    ))
                  )}
                </div>
              </Panel>
            ))}
          </Collapse>
        </div>
      </div>
    </Spin>
  );
};

EditTab.propTypes = {
  productTypes: PropTypes.array,
};

EditTab.defaultProps = {
  productTypes: [],
};

export default EditTab;
